import styled from "styled-components";

export const HeaderMasterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-inline: 25px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  max-width: 1400px;
  padding: 24px;
  border: 0.5px solid #bababa;
  border-radius: 16px;
  background: #ffffff;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: space-between;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const TagsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TagSeparator = styled.span`
  color: #5c5c5c;
  font-size: 12px;
  user-select: none;
`;

export const AvatarProfile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AvatarDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Name = styled.div`
  font-family: ${({ theme }) => theme?.fonts?.family?.primary || "Inter"};
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0.25px;
  color: #000000;
`;

export const LastConnection = styled.div`
  font-family: ${({ theme }) => theme?.fonts?.family?.primary || "Inter"};
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #5c5c5c;
`;

export const ContactDetailsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
`;

export const PersonalDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  width: fit-content;
  & span:first-child {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #5c5c5c;
    font-size: 18px;
  }
  & div {
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: nowrap;
  }
`;

export const PersonalDetailsItem = styled.div`
  font-family: ${({ theme }) => theme?.fonts?.family?.primary || "Inter"};
  font-weight: ${({ theme }) => theme?.fonts?.weight?.regular || "400"};
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  text-decoration: underline;
  color: #5c5c5c;
  flex-shrink: 1;
  max-width: fit-content;
  pointer-events: auto;
`;

export const CircleButton = styled.button`
  font-size: 12px;
  font-weight: ${({ theme }) => theme?.fonts?.weight?.medium || "500"};
  border-radius: 16px;
  background-color: white;
  border: 1px solid #5c5c5c;
  color: #5c5c5c;
  width: 39px;
  height: 28px;
  min-width: 39px;
  max-width: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  pointer-events: auto;
  padding: 0;
  margin: 0;
  text-align: center;
  line-height: 1;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${({ theme }) => theme?.colors?.hoverGrey};
    border-color: ${({ theme }) => theme?.colors?.dune};
  }
  
  &:active {
    background-color: ${({ theme }) => theme?.colors?.ariaGray};
  }
`;

export const ButtonsDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 5px;
`;

export const ActionsButton = styled.div`
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
`;

export const TabSwitcherContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1400px;
`;

export const TabSubContainer = styled.div`
  width: 100%;
  max-width: 1400px;
`;

export const TabRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1400px;
`;

export const DepartmentSelectWrapper = styled.div`
  max-width: 120px;
  width: 100%;
`;